import React from "react";
import { Container } from "react-bootstrap";
import "../assets/css/ContentScreens.css";

const HistoryScreen = () => {
  return (
    <Container className="content-screen">
      <h1>About ESC</h1>
      <section>
        <h2>
          <em>Ellicottville Ski Club History Part I 1935 – 1968</em>
        </h2>
        <h6>
          <em>
            A page from the ESC history book as written by Tom Carroll and
            finished in the late 1980s.
          </em>
        </h6>
        <p>
          Many of the members of this club may be wondering about the group of
          pictures recently placed on the clubhouse wall, why they are there and
          who the people are. They are pictures of members and events that took
          place during the early years of the Ellicottville Ski Club. These
          pictures have been scattered around various places, and the feeling of
          many of the older members of the club was that an attempt be made to
          collect them and hang them in the club before they disappear forever.
        </p>
        <p>
          The Ellicottville Ski Club is probably the oldest, still active ski
          club in this area. It all began in 1935 when a group of people in
          Ellicottville decided skiing would be a lot more enjoyable if they had
          a method of being pulled up the hills and eliminate the walking. They
          made their plans and decided to install a rope tow on Fish Hill, which
          is about half way between Ellicottville and Little Valley.
        </p>
        <p>
          It is interesting to note that this tow was in operation for the
          winter of 1935-1936. According to Ezra Bowen, then the ski editor of
          &#8220;"Sports Illustrated"&#8221; in his book,{" "}
          <em>American Skiing</em>, the first permanent ski lift in the United
          States was installed on Gilbert's Hill in Woodstock, Vermont for use
          in the winter of 1934-35. It also was a rope tow.
        </p>
        <p>
          From this information it is evident that Ellicottville was among the
          pioneers in this country who helped bring about the tremendous
          interest in downhill skiing. The people who were most responsible for
          this installation were:
        </p>
        <p>Bill Northrup Tim Stokes</p>
        <p>Don Brooks Zeke Slating</p>
        <p>
          In 1938, the people skiing in Ellicottville decided to form a ski
          club, and to no one's surprise, it was called the Ellicottville Ski
          Club. The first meeting was held on 11/10/38 and the following were
          elected officers and directors:
        </p>
        <p>Dr. Northrup, President</p>
        <p>Isobel Northrup, Treasurer</p>
        <p>Lillian Russow, Secretary</p>
        <p>Directors: A. E. Fraser</p>
        <p>Dr. G. D. Stone</p>
        <p>Tim Stokes</p>
        <p>Irene Russow</p>
        <p>Clarence Slating (Zeke)</p>
        <p>
          One of the original requirements to be an officer or a director was
          that the person had to be a resident of Ellicottville, but soon skiers
          began to trickle in from out of town, and this requirement was soon
          by-passed.
        </p>
        <p>
          Fish Hill was used for a few years, but it was apparent it was the
          coldest and windiest hill in Western New York, and to make matters
          worse, it wasn't much of a ski hill, either. In 1938, the members
          decided to find another hill that would be protected from the wind and
          be more of a challenge. They decided on Greer Hill. This hill is
          located in town and is directly across from the Catholic church.
        </p>
        <p>
          In 1939 the hill was cleared. The word, "cleared," is being used very
          loosely in this case. The following winter, skiing began on Greer.
          This location proved to be better protected from the elements than
          Fish, and to say it was more challenging, surpassed their fondest
          expectations. To put a beginning skier on top of the hill and tell him
          to "go for it," would be similar to placing a beginning mountain
          climber on top of Mount Everest and giving him the same instructions.
          Many of the people who skied there for the first time will tell you it
          was the single most traumatic experience of their lives.
        </p>
        <p>
          There were two vastly different factors that contributed to the
          success and the tradition of the club. The first was Mrs. Weller, the
          owner of the Lincoln Hotel, now the Ellicottville Inn, in town. She
          had a beautiful and wonderful philosophy of how to run a hotel. All
          she asked was that people come to the hotel for their luncheons,
          dinners and meetings, and to enjoy themselves. The thought of making a
          profit never entered her head. Fortunately, as we found out later,
          money was one thing she did not need.
        </p>
        <p>
          To make this situation more fantastic, she loved skiers. From Friday
          night until Sunday night, the only people she would give rooms to had
          to be skiers. As a consequence, all through the forties and most of
          the fifties, the Lincoln was the home of the ski club. Every weekend
          throughout the winter they would all gather at the hotel and spend the
          evening in the so-called "Drinking Room," drinking beer, telling their
          latest harrowing experiences on Greer, telling stories and lies, and
          singing most of the night away. They were not scattered all over town,
          because everyone who skied was there, and it created a togetherness
          and fellowship that is still evident.
        </p>
        <p>
          The other factor was that one of the members ventured north into
          Canada, and came back to spread the gospel that there was a Valhalla
          on earth for skiers--the Laurentian Mountains, north of Montreal, and
          "God," who took the name of Chink Walker, had his throne in a place
          called "The Pub," in St. Sauveur.
        </p>
        <p>
          At first, only a few made the trip, but soon it was like an act of
          faith. It was not only a vacation, it was a pilgrimage. The sights,
          the sounds, the people were so different that it was a new world. They
          skied on hill 69, 70 and 71 in St. Sauveur. Or they would take to the
          Maple Leaf Trail and stop at those "far away places with the strange
          sounding names," such as Piedmont, Mont Rolland, St. Marguerite, Val
          Morin, Val David, St. Agathe-Des Monts, St. Adele, and many others.
          They had a favorite pub in each of the towns. At noon they would have
          their favorite lunch of a couple of quarts of Molson's, and sometimes,
          some of them were known to eat, though this was not the norm.
        </p>
        <p>
          But no matter where they were, at night it was back to The Pub. There,
          vast quantities of Molson's would vanish. Sometimes it was used to
          wash down the delicious French pastries that were served, but most of
          the time it was used medicinally to lubricate their throats as "God"
          lead them in song. A great number of the songs that we used to sing
          well, but that now we just mumble and forget the words, originated
          there. This continued until the time came when so-called progress in
          the Laurentians got to the point that it was now evident that
          Ellicottville was more like a town in the Laurentians than St. Sauveur
          had been.
        </p>
        <p>
          In the meantime, there were a few deficiencies on Greer that needed
          correcting. The first and most pressing was the rope tow. To say the
          original installation smacked of "Rube Goldberg" would be putting it
          mildly. The pulleys that supported the rope were the front wheels from
          old Chevrolets. They were mounted on trees and were anywhere from 20"
          to 30" off the ground and were just a tad out of line. As a result the
          rope had a nasty habit, either when skiing was the best, or when the
          temperature was 0 degrees or below, to either come off the pulley or
          to break. Anyone who has not experienced the pleasure of shinning up a
          thirty foot tree to replace a rope, or help make a 25" long
          transmission splice in a rope, with the temperature 0 degrees or below
          (sometimes at night) doesn't know one of the real thrills of skiing in
          the "Good Old Days."
        </p>
        <p>
          In 1947 the members decided the thrill was gone in maintaining the old
          tow and the entire contraption should be replaced. At the same time it
          was decided that the shelter we had was inadequate as well. There was
          some objection to this, but stronger heads prevailed and decided that
          a building approximately 15" square, that housed a 100 H.P. motor, a
          6" flywheel, a 100 H.P. starter, a pot-belly stove and about 30 half
          frozen skiers, truly was inadequate and should be replaced.
        </p>
        <p>
          At that time, whatever the ski club decided to do, the members did it.
          All the maintenance, clearing the hill in the fall, and new
          construction was a part of the privilege of being a member. That fall
          was the busiest in the history of the club. The steel was ordered
          along with the concrete for the footings for the poles and the lumber
          for the new shelter. All this material was carried up the hill by the
          members and erected by them. If at that time some misguided fool had
          suggested to a member that he knew of a book that outlined a series of
          exercises to get in shape for skiing, he would have been strangled on
          the spot, and any court in the country, after being informed of the
          facts, would bring in a verdict of justifiable homicide.
        </p>
        <p>
          The work was completed in time for the ski season and the results were
          a shelter that all of the members, still half frozen, could use at the
          same time. The rope still fell off the pulleys and broke, but now it
          happened in a more sophisticated and scientific manner. With the new
          "improvements" we happily skied, drank Molson's and sang our way
          through the late forties and early fifties.
        </p>
        <p>
          The problem of maintaining the hill resulted in the necessity for
          having the spring party. Each year the rope had to be removed from the
          hill and stored for the summer. This rope was no toy balloon, either.
          To make sure there were enough able-bodied hands, great effort was
          made to have a party that would be the best of the year. It became a
          must on every member's calendar. Some of the parties were real barn
          burners. Unfortunately, with the passing of necessity to remove the
          rope, the necessity of the spring party was also removed, and one of
          the high spots of our ski season fell by the wayside.
        </p>
        <p>
          In the early spring, when Greer was no longer skiable, the members
          would use the tow to take them to the top of the hill and ski cross
          country along the top of the ridge over to the fire tower and then
          down what is now called Mardi Gras, into town. It was noticed that the
          valley between Greer and the fire tower held snow longer, and more of
          it, than any other valley in the area. This information was stored
          away for future consideration.
        </p>
        <p>
          In the late fifties, things began to change rapidly. In 1955 Mrs.
          Weller died, the hotel was sold, and we were no longer welcome there.
          At the same time up on Greer, members were finding they had fairly
          well mastered the hill as far as skiing was concerned, but the rope
          tow was beginning to master their aging arms. The members began
          looking at the valley on the other side of Greer and playing with the
          idea of a ski resort in that valley. In 1957 several members formed a
          corporation and began the development of what is now Holiday Valley.
        </p>
        <p>
          As the Valley rapidly developed, it presented a new dilemma for the
          ski club. An attempt was made to continue using Greer, but as members
          saw what was developing in the valley -T-bar lifts, groomed hills,
          restaurants and <span className="roif">rest rooms</span> they began to
          abandon Greer and move over to the Valley. As the Valley progressed
          along with the influx of new skiers into the town, there was no longer
          a place for the members of the ski club to get together.
        </p>
        <p>
          At that time, one of the members of the club, Dutch Roy, opened a ski
          lodge, and in the back of his property was an abandoned barn that he
          allowed us to use for our parties and meetings. In 1958 began the era
          of Dutch's barn. Once again the members had a place to meet on
          Saturday night. The days of drinking Molson's was gone, and in its
          place came Martinis and Manhattans, but once again we had a place
          where we could drink, tell our stories and lies and sing ourselves
          hoarse.
        </p>
        <p>
          We had a great time for a couple of years and had one distinction that
          was unique. We are without doubt the only ski club anywhere which can
          boast that they entertained several of the original astronauts in a
          dilapidated barn.
        </p>
        <p>
          Once again a problem arose. We were using the facilities of the lodge
          and putting a severe strain on its operation and the friendship of the
          owner. In 1960 at a summer party at Yacht Harbor, it was decided to
          build a club house in Holiday Valley. It was decided this should be
          accomplished for $15,000 or less. This figure was{" "}
          <span style={{ textDecoration: "underline" }}>slightly</span> low and
          explains why the club is still paying off bonds that had to be sold to
          take care of this minor miscalculation. However, on New Year's Eve of
          1960, the first party was held in our new club house. As we had signed
          a ten-year lease with the valley, and with an option to buy, we had
          eliminated the problem of holding the club members together.
        </p>
        <p>
          The building of the club house was the bridge between the old ski club
          and the new. As the club flourished through the years, it became
          necessary in 1965 to expand and another room was added. The club has
          remained over the years, vital and progressive, as can be testified by
          the fact that there is discussion at the present time of the need for
          future expansion. We are looking forward to 1988 when we will
          celebrate our Golden Anniversary.
        </p>
        <p> </p>
      </section>

      <section>
        <h2>
          <em>Ellicottville Ski Club History Part II 1968 – 2019</em>
        </h2>
        <h6>
          <em>As observed by Korky Kantowski</em>
        </h6>
        <p>
          The first expansion of the Clubhouse was voted on in 1968. The south
          wall was extended out its entire length, giving the members much more
          room with the addition of tables and chairs and an indoor grill. Prior
          to the addition, the only gathering place was around the fireplace.
        </p>
        <p>
          Two years after the expansion, Holiday Valley decided to put in a new
          chair lift ... and guess where? Yes, just east of the Club. We now had
          ski-out and ski-in access to the slopes. The chair lift and trail
          below it was called the "Chute". We could not have planned it better,
          had we been involved in the decision!
        </p>
        <p>
          Membership remained strong through the 70s and 80s. Applicants were
          put on a "waiting list", and that applicant list procedure continues
          today.
        </p>
        <p>
          Holiday Valley continued to expand and improve during this time, as
          did the entire surrounding communities. Wow!!
        </p>
        <p>
          In 1983, another move to expand the Club's facilities was underway.
          This renovation was to the east, facing the Chute Chair. A positive
          vote was held and a bond issue sold, and with the financing in place,
          construction was completed for the 1984-1985 season. This expansion
          included the lower level and main floor, offering plenty of room for
          ski and boot storage, as well as additional seating and table space on
          the main floor.
        </p>
        <p>
          This decade saw the 50<sup>th</sup> Anniversary of the Ellicottville
          Ski Club. A gala event was arranged and fully attended in the winter
          of 1988. A packed house with formal attire made for a wonderful
          evening. What a night, with skits and all, emceed by Jim Ramsey, with
          Cupie Cox leading us in a favorite song, "They Never Mention Aunt
          Clara".
        </p>
        <p>
          This event also served as an opportunity for the Social Committee to
          re-think the Saturday night parties, which was a long-standing
          tradition. A formal Presidents' Ball was added as annual event,
          honoring all past presidents of ESC. The "Sing-A-Long" was also
          included as the Season Opener for the social events, to keep that
          tradition intact.
        </p>
        <p>
          Speaking of social events, the "Titanic" themed event in February of
          1999 was arguably the best Club social event ever held. A sold-out
          crowd had members signing up for either "First Class" or "Steerage"
          tickets, with dress appropriate for your class of service. The menu
          was also "class of service" inspired, with beef tenderloin for those
          in First Class and Irish stew in Steerage! A 24-foot replica of the
          port side of the Titanic ship covered the south wall of the Club. A
          4-foot Titantic cake was designed, baked, and decorated by Charlotte
          Burnham, which took 16 boxes of cake mix to create. A violinist set
          the mood in the first class section, while Irish jigs were played in
          Steerage. The entire facility was festooned with complementary décor.
          Congratulations to the committee, headed by Barbara Graham and Mabel
          Grainger, and many volunteers, for that one!
        </p>
        <p>
          The last decade of the 20<sup>th</sup> century, and the first of the
          21
          <sup>st</sup>, proved to be fairly active for the Club. The annual
          Mardi Gras weekend in early March in Ellicottville continued to be a
          big hit. There were two particular events that attracted the Club's
          involvement, with the first being the Saturday night parade in the
          village. The second was the Dummy Downhill, held on the lower portion
          of the Yodeler slope.
        </p>
        <p>
          The Club entered the parade seven times, garnering 1<sup>st</sup>{" "}
          place 6 times, and 2<sup>nd</sup> place once. Each year, Bob
          Truckenbrod would do an artist's rendering of our float entry, and
          also produced and directed the entire undertaking.
        </p>
        <p>The winning floats were:</p>
        <p>
          Alice in Wonderland (1<sup>st</sup> Place)
        </p>
        <p>
          101 Dalmatians (1<sup>st</sup> Place)
        </p>
        <p>
          The Vikings (1<sup>st</sup> Place)
        </p>
        <p>
          Harry Potter (1<sup>st</sup> Place)
        </p>
        <p>
          Grateful Dead (1<sup>st</sup> Place)
        </p>
        <p>
          Titanic (1<sup>st</sup> Place)
        </p>
        <p>
          The Lion King (2<sup>nd</sup> Place)
        </p>
        <p>
          Our thanks for the float entries went out to all who helped build the
          floats and to John Northrup for the use of one of his trucks each
          year. Many thanks to Mike Hess, who had the float's artist renderings
          matted and framed, and then donated them to the Club, where they are
          permanently on display.
        </p>
        <p>
          The Dummy Downhill was something else! Entrants would design an
          artificial skier and release it down the lower portion of Yodeler. A
          jump or two along the way would test the dummy's design and
          aerodynamic characteristics. Over time, we tested our membership's
          design abilities ... with little luck. Finally, one year Jim Blanchard
          put together a winner, deemed by crowd applause. Our entry was named
          "Miss Ellie Cottville." Nice going, Jim!
        </p>
        <p>
          We got through Y2K unscathed, with another memorable event to
          celebrate the year 2000. A new century was upon us. The spring of that
          year saw the bulldozing of the Middle Chalet, the first lodge built at
          Holiday Valley during the 1957-58 season. The old chalet was replaced
          with a world-class facility, to be called Yodeler Lodge.
        </p>
        <p>
          Not to be outdone, at the General meeting of the ESC in 2005 the
          members voted on a major reconstruction of the Clubhouse to be
          completed in the Fall of 2006. Bonds were sold for a total amount of
          $300,000 to finance the project. The old Clubhouse building was
          gutted, and the north side was bumped out about 6 feet on both levels.
          A permanent bar, built by Kevin McKnight, was installed and the
          kitchen was replaced and reconfigured to better serve the membership,
          featuring 2 double wall ovens and 2 separate sink areas, as well as a
          large serving counter ... lots of room for the "worker bees" plus all
          members and guests. Another gala social event celebrated the opening
          of this completely renovated facility in the fall of 2006.
        </p>
        <p>
          Around this same time a few ladies of the Club came up with their own
          version of a Ladies' Day event that had been held at Holimont. In
          2005, a small group of lady skiers gathered for a fun Friday of
          skiing, with lunch following at Holiday Valley. What started as a
          small group of ESC women enjoying a day of skiing together turned into
          an annual event, with nearly 50 lady skiers and about 100 lady
          members, spouses, and guests attending an evening charity dinner and
          auction. As of 2019, the ladies of ESC have raised nearly $90,000 for
          local charities! Helmets off to some of the early founders and Chairs
          of the event – Laura DeCinque, Holmes McGuigan-Webb, Debra Fierle,
          Lisa Colby, and Erin Fierle. In 2020 new chairs Susie Robbins and
          Diana Renaldo will step in, and who will make this special event their
          very own. And always many thanks to all the ladies who pitch in each
          year for this great ESC event that also benefits the community we ski
          in!
        </p>
        <p>
          In 2010, past-president Bill Hansen graciously presented a gift to the
          Club, referred to as "The Last Call Bell", which would serve two
          purposes. Situated over the back of the bar, the bell is rung during
          social events to signify that the event is concluding. In addition,
          the bell would go on to have a more solemn purpose. Going forward, at
          each General Meeting, the names of our members who departed the prior
          year are read, and one stroke of the bell is sounded, for each
          deceased member, representing a tribute and fond farewell to those
          members.
        </p>
        <p>
          Also in 2010, Holiday Valley held a contest to name the Holiday Valley
          Ski Queen during the annual Mardi Gras festivities. ESC was fortunate
          to claim the title 3 years in a row! By crowd applause, Holmes
          McGuigan-Webb was crowned Carnival Ski Queen in 2010, Maria Ponikvar
          in 2011, and Alicia Robinson Long in 2012. Congratulations ladies and
          thank you for doing ESC proud!
        </p>
        <p>
          The next decade found the membership enjoying their newly renovated
          facility. Fast approaching was the year 2013, representing the 75
          <sup>th</sup> Anniversary of the ski Club. Research was done by yours
          truly to see how we ranked in terms of the Club's standing as one of
          the oldest ski clubs in America. We are arguably the oldest chartered
          incorporated continuously active ski club in the United States!
        </p>
        <p>
          Now on to 2013. Sheri Barrera chaired the special event, along with a
          rather large group of volunteers. It was held on November 10, 2013,
          seventy-five years to the day when the when the Club was founded. The
          minutes of the first meeting of ESC were read by yours truly, and the
          remainder of the day was enjoyed by all in attendance, including
          children, reminiscing the past and anticipating the future. During the
          event, the song "Edelweiss" was adopted as the Ski Club's official
          song.
        </p>
        <p>
          At the 2018 General meeting, it was announced that a gift to the Club
          was received from the estate of Mary Ellen and Don Morrison, who had
          been members of the Club since 1959. The Morrison's cash gift was to
          be used for an appropriate purpose, and after polling the general
          membership the project selected was an outdoor fire pit, on a new
          concrete pad and complete with seating, just west of the Clubhouse and
          facing the Edelweiss slope. How appropriate, as the Morrisons loved
          sitting around the indoor fireplace with fellow members after skiing.
          Thank you to the Morrisons. We know how much you both enjoyed and
          loved the Ellicottville Ski Club.
        </p>
        <p>
          At the 2018 Annual Meeting, we recognized our longest-tenured member,
          Edna Northrup, whose husband Wilbur "Doc" Northrup was an original
          founding member of ESC and it's first president. Edna has been a
          member of the Club for 70 years!
        </p>
        <p>
          Let us remember that in addition to being a social club, ESC is also a
          ski club!! With that in mind, below is a list of members' children who
          went on to high levels of ski competition (more will be added as we
          get their details):
        </p>
        <p>
          <strong>U.S. Ski Team </strong>{" "}
        </p>
        <p>Penny Northrup Kirk – Alpine </p>
        <p>Travis Mayer – Freestyle </p>
        <p>Alex Wilson – Freestyle </p>
        <p>
          {" "}
          <strong>Division I Collegiate Skiing</strong>{" "}
        </p>
        <p>Anne Widger Northrup – Univ. of New Hampshire</p>
        <p>Genene Jarosz Crofut – University of Colorado</p>
        <p>Theresa Kantowski Martens – Univ. of Wyoming</p>
        <p>Peter &amp; Colin Martens &#8211; Univ. of New Hampshire</p>
        <p>
          As I write this brief history (Part II) I checked the calendar ... it
          was 80 years ago today, 11/10/1938, that the Ellicottville Ski Club
          was founded. What a treasure we have!
        </p>
        <p>
          p.s. And on a personal note, there may be an embellishment or two in
          the above recall of our club's history from 1968. My apologies!
        </p>
        <p>With pleasure, I submit these memories,</p>
        <p>Korky Kantowski</p>
      </section>
    </Container>
  );
};

export default HistoryScreen;
